import { FC, Fragment } from 'react'
import {
  StyleWrapper,
  StyleColumn,
  StyleMessageItemWrapper,
  StyleMessage,
  StyleTimeWrapper,
  StyleMessageFileGrid,
  StyleMessageFileItem,
  StyleMessageImage,
  StyleMessageFile,
  StyleCallRow,
} from './style'
import Typography from '@components/typography'
import Image from '@components/image'
import { format } from 'date-fns'
import { Constant } from '@utils'
import Svg from '@components/svg'
import Circle from '@components/circle'
import { intervalToDuration } from 'date-fns'
interface MessageItemProps {
  message: any
  sender
  receiver
}
const MessageItem: FC<MessageItemProps> = ({ message, sender, receiver }) => {
  const isOwner = sender?.id == message?.senderId
  const filterFiles = !!message?.infos?.files
    ? message?.infos?.files?.filter((file: any) => {
        if (file?.base64) {
          return !Constant.imageValidationExtensions.includes(file?.extension)
        } else {
          const splitFile = file.split('.')
          return !Constant.imageValidationExtensions.includes(splitFile.pop())
        }
      })
    : []
  const filterImages = !!message?.infos?.files
    ? message?.infos?.files?.filter((file: any) => {
        if (file?.base64) {
          return !!Constant.imageValidationExtensions.includes(file?.extension)
        } else {
          const splitFile = file.split('.')
          return !!Constant.imageValidationExtensions.includes(splitFile.pop())
        }
      })
    : []
  const duration = message?.infos?.status
    ? intervalToDuration({
        start: new Date(message?.infos?.duration?.startTime),
        end: new Date(message?.infos?.duration?.endTime),
      })
    : null
  return (
    <StyleWrapper isOwner={isOwner}>
      <StyleColumn>
        {!!filterImages?.length && (
          <StyleMessageItemWrapper>
            <StyleWrapper isOwner={isOwner}>
              <StyleMessageFileGrid>
                {filterImages.map((file: any, index: number) => {
                  return (
                    <Fragment key={index}>
                      <StyleMessageFileItem
                        data-cross-type={`image`}
                        data-cross-file={JSON.stringify(file)}
                      >
                        <StyleMessageImage
                          src={
                            !!file?.base64
                              ? `${file?.info},${file?.base64}`
                              : file
                          }
                        />
                      </StyleMessageFileItem>
                    </Fragment>
                  )
                })}
              </StyleMessageFileGrid>
            </StyleWrapper>
          </StyleMessageItemWrapper>
        )}
        {!!filterFiles?.length && (
          <StyleMessageItemWrapper>
            <StyleWrapper isOwner={isOwner} style={{ rowGap: 15 }}>
              {filterFiles.map((file: any, index: number) => {
                return (
                  <Fragment key={index}>
                    <StyleMessageFile
                      data-cross-type={`file`}
                      data-cross-file={JSON.stringify(file)}
                    >
                      <Svg svg="document" color="black" />
                      <Typography
                        content={
                          !!file?.base64
                            ? file?.fileName
                            : file.split('/').pop()
                        }
                        size={12}
                      />
                    </StyleMessageFile>
                  </Fragment>
                )
              })}
            </StyleWrapper>
          </StyleMessageItemWrapper>
        )}
        {!!message?.infos?.message && (
          <StyleMessageItemWrapper>
            {!isOwner && (
              <Image
                src={`${process.env.BUCKET_URL}/${receiver?.avatar}`}
                fallbackType="user"
                height={25}
                width={25}
                styleImage="border-radius:50%"
                alt={sender?.name}
              />
            )}
            <StyleMessage isOwner={isOwner}>
              <Typography
                content={message?.infos?.message}
                size={14}
                tc={!!isOwner ? 'white' : 'text'}
              />
              <StyleTimeWrapper>
                <Typography
                  content={format(new Date(message?.createdAt), `hh:mm aa`)}
                  size={10}
                  tc={'iconPrimary'}
                />
              </StyleTimeWrapper>
            </StyleMessage>
          </StyleMessageItemWrapper>
        )}
        {!!message?.infos?.status && (
          <StyleMessageItemWrapper>
            {!isOwner && (
              <Image
                src={`${process.env.BUCKET_URL}/${receiver?.avatar}`}
                fallbackType="user"
                height={25}
                width={25}
                styleImage="border-radius:50%"
                alt={sender?.name}
              />
            )}
            <StyleMessage isOwner={isOwner}>
              <StyleCallRow>
                <Circle
                  bg={
                    message?.infos?.status == 'No Response'
                      ? 'danger'
                      : 'white100'
                  }
                >
                  <Svg
                    svg={message?.infos?.call == 'video' ? 'video' : 'call'}
                    color={'white'}
                  />
                </Circle>
                <Typography
                  content={`${message?.infos?.status == 'No Response' ? 'Missed' : ''} ${message?.infos?.call} call`}
                  size={14}
                  tc={!!isOwner ? 'white' : 'text'}
                  styleText="text-transform:capitalize;"
                />
              </StyleCallRow>
              {message?.infos?.status == 'Answered' && (
                <Typography
                  content={`${duration.minutes || 0} mins ${duration.seconds} secs`}
                  size={14}
                  styleText="text-align:right"
                  tc={!!isOwner ? 'white' : 'text'}
                />
              )}
              <StyleTimeWrapper>
                <Typography
                  content={format(new Date(message?.createdAt), `hh:mm aa`)}
                  size={10}
                  tc={'iconPrimary'}
                />
              </StyleTimeWrapper>
            </StyleMessage>
          </StyleMessageItemWrapper>
        )}
      </StyleColumn>
    </StyleWrapper>
  )
}

export default MessageItem
